import { Fragment, useRef, useState, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/24/outline";

export default function AddSale({
  addSaleModalSetting,
  products,
  stores,
  handlePageUpdate,
  authContext,
}) {
  const [sale, setSale] = useState({
    userID: authContext.user,
    productID: "",
    storeID: "",
    stockSold: "",
    saleDate: "",
    totalSaleAmount: "",
    pricePerUnit: "",
  });
  const [currentStock, setCurrentStock] = useState(null); // To display in_stock
  const [open, setOpen] = useState(true);
  const cancelButtonRef = useRef(null);

  // Update pricePerUnit and currentStock when productID changes
  useEffect(() => {
    if (sale.productID) {
      const selectedProduct = products.find(
        (p) => p.product_id === parseInt(sale.productID)
      );
      if (selectedProduct) {
        setSale((prev) => ({
          ...prev,
          pricePerUnit: selectedProduct.price_per_unit.toString(),
        }));
        setCurrentStock(selectedProduct.in_stock);
      }
    } else {
      setCurrentStock(null);
      setSale((prev) => ({ ...prev, pricePerUnit: "" }));
    }
  }, [sale.productID, products]);

  // Handling Input Change for input fields
  const handleInputChange = (key, value) => {
    const trimmedValue = value.trim();
    setSale((prev) => {
      const updatedSale = { ...prev, [key]: trimmedValue };

      // Automatically calculate totalSaleAmount when stockSold or pricePerUnit changes
      if (key === "stockSold" || key === "pricePerUnit") {
        const qty = parseInt(updatedSale.stockSold) || 0;
        const price = parseFloat(updatedSale.pricePerUnit) || 0;
        updatedSale.totalSaleAmount = (qty * price).toFixed(2);
      }

      return updatedSale;
    });
  };
const addSale = () => {
  const payload = {
    user_id: sale.userID,
    product_id: sale.productID,
    store_id: sale.storeID,
    stock_sold: parseInt(sale.stockSold),
    sale_date: sale.saleDate,
    total_sale_amount: parseFloat(sale.totalSaleAmount),
    price_per_unit: parseFloat(sale.pricePerUnit),
  };

  console.log("Sending payload to PHP:", payload);

  fetch("https://stock.krishtec.co.in/stock/add_sale.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => {
      console.log("Response status:", response.status);
      return response.text(); // Get raw text instead of JSON
    })
    .then((text) => {
      console.log("Raw Response:", text); // Log the raw response
      const data = JSON.parse(text); // Attempt to parse
      console.log("Parsed Response:", data);
      if (data.message === "Sale added successfully") {
        alert(data.warning
          ? "Sale ADDED but Stock NOT Updated: " + data.warning
          : "Sale ADDED and Stock Updated");
        handlePageUpdate();
        addSaleModalSetting();
      } else {
        alert("Error: " + data.message);
      }
    })
    .catch((err) => {
      console.log("Fetch error:", err);
      alert("Failed to add sale");
    });
};

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={() => {
          setOpen(false);
          addSaleModalSetting();
        }}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg overflow-y-scroll">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                      <PlusIcon
                        className="h-6 w-6 text-blue-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                      <Dialog.Title
                        as="h3"
                        className="text-lg py-4 font-semibold leading-6 text-gray-900"
                      >
                        Add Sale
                      </Dialog.Title>
                      <form action="#">
                        <div className="grid gap-4 mb-4 sm:grid-cols-2">
                          <div>
                            <label
                              htmlFor="productID"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                              Product Name
                            </label>
                            <select
                              id="productID"
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                              name="productID"
                              onChange={(e) =>
                                handleInputChange(e.target.name, e.target.value)
                              }
                            >
                              <option value="">Select Product</option>
                              {products.map((element) => (
                                <option
                                  key={element.product_id}
                                  value={element.product_id}
                                >
                                  {element.product_name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div>
                            <label
                              htmlFor="storeID"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                              Store Name
                            </label>
                            <select
                              id="storeID"
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                              name="storeID"
                              onChange={(e) =>
                                handleInputChange(e.target.name, e.target.value)
                              }
                            >
                              <option value="">Select Store</option>
                              {stores.map((element) => (
                                <option key={element.id} value={element.id}>
                                  {element.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div>
                            <label
                              htmlFor="stockSold"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                              Stock Sold
                            </label>
                            <input
                              type="number"
                              name="stockSold"
                              id="stockSold"
                              value={sale.stockSold}
                              onChange={(e) =>
                                handleInputChange(e.target.name, e.target.value)
                              }
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                              placeholder="0 - 999"
                              min="0"
                            />
                            {currentStock !== null && (
                              <span className="text-xs text-gray-500">
                                Current Stock: {currentStock}
                              </span>
                            )}
                          </div>
                          <div>
                            <label
                              htmlFor="pricePerUnit"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                              Price Per Unit
                            </label>
                            <input
                              type="number"
                              name="pricePerUnit"
                              id="pricePerUnit"
                              value={sale.pricePerUnit}
                              onChange={(e) =>
                                handleInputChange(e.target.name, e.target.value)
                              }
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                              placeholder="$0.00"
                              min="0"
                              step="0.01"
                            />
                          </div>
                          <div>
                            <label
                              htmlFor="totalSaleAmount"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                              Total Sale Amount
                            </label>
                            <input
                              type="number"
                              name="totalSaleAmount"
                              id="totalSaleAmount"
                              value={sale.totalSaleAmount}
                              readOnly
                              className="bg-gray-200 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                              placeholder="$0.00"
                            />
                          </div>
                          <div className="h-fit w-fit">
                            <label
                              htmlFor="saleDate"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                              Sale Date
                            </label>
                            <input
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                              type="date"
                              id="saleDate"
                              name="saleDate"
                              value={sale.saleDate}
                              onChange={(e) =>
                                handleInputChange(e.target.name, e.target.value)
                              }
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                    onClick={addSale}
                  >
                    Add Sale
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={() => {
                      setOpen(false);
                      addSaleModalSetting();
                    }}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}